import React from "react";

const PrivacyPolicyBanner = ({ bannerDismiss }) => {
    // prettier-ignore
    return (
        <section
            className="banner banner-flex info"
            data-callback="accounts/hide-privacy-banner"
            data-banner-show-anonymous="true"
        >
            <div className="banner-grid row">
                <span className="info">
                    <span>
                        We’ve updated our <a href="/legal/terms-of-use/">Terms of Use</a> &amp; <a href="/legal/privacy-policy/">Privacy Policy</a> to launch Photos
                    </span>
                </span>

                <span
                    className="dismiss-banner ui_close"
                    onClick={bannerDismiss}
                    title="Dismiss banner"
                />
            </div>
        </section>
    );
};

export default PrivacyPolicyBanner;
